/* eslint-disable check-file/filename-naming-convention */
import React from 'react';
import ReactDOM from 'react-dom/client';

import './theme.common.less';
import './theme/fonts.css';
import './theme/lseg.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

import { App } from './App';
import { getPwaManifestBlobUrl } from './pwa-manifest';
import { getAccessTokenFromCookie, handleLoginFlow } from './services/auth';
import { Telemetry } from './services/telemetry/telemetry';

if (process.env.NODE_ENV !== 'production') {
  void import('@axe-core/react').then((axe) => {
    void axe.default(React, ReactDOM, 1000);
  });
}

if (process.env.NODE_ENV !== 'test') {
  Telemetry.setConfig({
    authToken: () => Promise.resolve(getAccessTokenFromCookie()),
    paused: false,
  });
}

function setPageMetadata() {
  document.title = window.CONFIG.branding.longName;
  document.head.querySelector('#meta-description')?.setAttribute('content', window.CONFIG.branding.strapLine);
  document.head.querySelector('#link-manifest-pwa')?.setAttribute('href', getPwaManifestBlobUrl());
}

function createInstance() {
  const rootElem = document.getElementById('root');
  if (!rootElem) {
    return;
  }

  const user = handleLoginFlow();
  if (!user) {
    // already redirecting
    return;
  }

  const root = ReactDOM.createRoot(rootElem);
  root.render(
    <React.StrictMode>
      <App user={user} />
    </React.StrictMode>
  );
}

setPageMetadata();
createInstance();
